class Exhibition {
  constructor (exhibition = {}) {
    // Defaults via destructuring: evita el if/else y los ternarios por campo
    // (mantiene baja la complejidad y el mismo contrato de salida).
    const {
      id = null,
      content = null,
      exhibition_product_id = null,
      exhibition_type_id = null,
      type_name = null,
      location_id = null,
      display_place = null,
      promoter_id = null,
      supervisor_id = null,
      status = 'active',
      active_days = 0,
      created_by = null,
      created_at = null,
      finalized_at = null,
      type = null,
      location = null,
      location_data = null,
      promoter_data = null,
      supervisor_data = null,
      can_manage, // sin default a proposito: undefined significa "el back no lo manda"
      evidences = []
    } = exhibition || {}

    this.id = id
    this.content = content
    this.exhibition_product_id = exhibition_product_id
    this.exhibition_type_id = exhibition_type_id
    this.type_name = type_name || (type && type.name) || null
    this.location_id = location_id
    this.location = Exhibition.locationLabel(location_data, location)
    this.display_place = display_place
    this.promoter_id = promoter_id
    this.promoter = Exhibition.fullName(promoter_data)
    this.supervisor_id = supervisor_id
    this.supervisor = Exhibition.fullName(supervisor_data)
    this.status = status || 'active'
    this.active_days = active_days
    this.created_by = created_by
    this.created_at = created_at
    this.finalized_at = finalized_at
    // Lo resuelve el back (accessor can_manage): el supervisor que ve la exhibicion
    // por jerarquia, sin haberla creado, la tiene en modo lectura.
    // Si el back no envia el campo (version anterior) se asume gestion permitida: asi
    // un front desplegado antes que el back no le quita los botones al propio promotor.
    // La ultima palabra siempre es el 403 del back; esto solo decide que UI se muestra.
    this.canManage = can_manage === undefined ? true : can_manage === true
    this.evidences = evidences || []
  }

  // Nombre completo a partir del objeto de usuario (promotor/supervisor).
  static fullName (user) {
    if (!user) return null
    return `${user.first_name || ''} ${user.last_name || ''}`.trim()
  }

  // Etiqueta de ubicacion SIEMPRE como string: location_data puede venir como objeto
  // o como texto segun la respuesta del API; se normaliza para no mostrar [object Object].
  static locationLabel (locationData, location) {
    if (locationData && typeof locationData === 'object') {
      return locationData.full_name || locationData.name || null
    }
    if (locationData) return locationData
    if (location) return location.name || location.full_name || null
    return null
  }

  get isFinished () {
    return this.status === 'finished'
  }

  // Solo las fotos de la bitacora (excluye eventos created/updated/finished).
  get pictures () {
    return this.evidences.filter(e => e.type === 'picture')
  }
}

export default Exhibition
